// modules/pageHeaderShrink.js
// After SCROLL_THRESHOLD px: shrinks .page-header__title and fades in a
// progressive backdrop-blur band (.page-blur-band) injected below .page-header.

const SCROLL_THRESHOLD = 200;

let title = null;
let blurBand = null;
let onScroll = null;

export function init() {
    title = document.querySelector('.page-header__title');

    blurBand = document.createElement('div');
    blurBand.className = 'page-blur-band';
    document.body.appendChild(blurBand);

    onScroll = () => {
        const scrolled = window.scrollY >= SCROLL_THRESHOLD;
        title?.classList.toggle('page-header__title--reduced', scrolled);
        blurBand.classList.toggle('page-blur-band--visible', scrolled);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
}

export function destroy() {
    if (onScroll) window.removeEventListener('scroll', onScroll);
    title?.classList.remove('page-header__title--reduced');
    blurBand?.remove();
    title = null;
    blurBand = null;
    onScroll = null;
}
